import sweetFactoryStoreLogo from '@rewardopl/assets/logos/sweetfactorystore.svg';

import { Image, Wrapper } from './vendor_logo.styles';

import { VENDOR_BUSINESS_NAME } from '../../constants';

type VendorLogoProps = { width?: number };

export default function VendorLogo({ width = 180 }: VendorLogoProps) {
  const height = width;

  return (
    <Wrapper>
      <Image alt={VENDOR_BUSINESS_NAME} height={height} src={sweetFactoryStoreLogo} width={width} />
    </Wrapper>
  );
}
